import { createI18n } from 'vue-i18n';
import { i18nManager } from '@ozdao/martyrs/modules/core/client';

import translations from './translations.js';
import overrides from './overrides.js';
import extensions from './extensions.js';

const supportedLocales = {
  ru: "🇷🇺 RU"
};

export function getLocales() {
  i18nManager.setSupportedLocales(supportedLocales);

  if (translations) {
    Object.entries(translations).forEach(([module, locales]) => {
      i18nManager.register(module, locales);
    });
  }

  if (extensions) {
    Object.entries(extensions).forEach(([module, locales]) => {
      i18nManager.extend(module, locales);
    });
  }

  if (overrides) {
    Object.entries(overrides).forEach(([module, locales]) => {
      i18nManager.override(module, locales);
    });
  }

  const messages = i18nManager.getAllMessages();

  const i18n = createI18n({
    legacy: false,
    locale: 'ru',
    fallbackLocale: 'ru',
    messages,
    globalInjection: true,
    availableLocales: Object.keys(supportedLocales),
  });

  i18nManager.setI18nInstance(i18n);

  return i18n;
}
